import React, { ReactElement } from 'react'
import Scrollbars from 'react-custom-scrollbars'
import classNames from 'classnames'

import { Footer } from '../components'

interface IMainLayout {
    pageHeader?: ReactElement
    pageContent: ReactElement
    scrollBarExtraClassName?: string
    hide?: boolean
}

export const MainLayout = ({ pageHeader, pageContent, scrollBarExtraClassName, hide }: IMainLayout) => {
    console.log("Render MainLayout")
    return (
    <div style={hide ? {display: 'none'} : undefined}>
        {pageHeader}
        <Scrollbars className={classNames('scroll-wrapper', scrollBarExtraClassName)} >
            {pageContent}
            <Footer />
        </Scrollbars>
    </div>
    )
}